import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./Common.css";
import DashboardLayout from "./pages/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import LoanProduct from "./pages/LoanProduct";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthRoute from "./components/AuthRoute";
import SingleLoanProduct from "./pages/SingleLoanProduct";
import DealerBonus from "./pages/DealerBonus";
import ScrollToTop from "./components/ScrollToTop";
import { createContext, useEffect } from "react";
import { useQuery } from "react-query";
import axios from "./axios/axios";
import PageLoader from "./components/PageLoader";
import { useState } from "react";
import Profile from "./pages/Profile/Profile";
import CaseList from "./pages/LoanApplicationCases/CaseList";
import CaseDetails from "./pages/LoanApplicationCases/CaseDetails";
import DownloadDocuments from "./pages/LoanApplicationCases/DownloadDocuments";
import ApplicationCaseStatus from "./pages/LoanApplicationCases/ApplicationCaseStatus";
import PreviewAA from "./pages/LoanApplicationCases/PreviewAA";
import CaseSumary from "./pages/LoanApplicationCases/CaseSumary";
import GuarantorDetailsComponent from "./pages/LoanApplicationCases/GuarantorDetailsComponent";
import ViewAA from "./pages/LoanApplicationCases/ViewAA";
import ViewApplicationForm from "./pages/LoanApplicationCases/ViewApplicationForm";
import Aasetup from "./pages/AaSetup";
import NotificationLayout from "./pages/Notification";
import { useDispatch, useSelector } from "react-redux";
import { update } from "./redux/slice/settingsSlice";
import UserAccounts from "./pages/UserAccounts";
import UserRoles from "./pages/UserRoles";
import FlooringRates from "./pages/FlooringRates";
import FlooringVouchers from "./pages/FlooringVouchers";
import ProtectedRoute from "./common/ProtectedRoute";
import { HasPermission } from "./common/Constants";
import NoPermission from "./pages/NoPermission";
import BonusSummary from "./pages/BonusSummary";
import DetailSummary from "./pages/DetailSummary/DetailSummary";
import PaymentHistory from "./pages/DetailSummary/PaymentHistory";
import FlooringCases from "./pages/FlooringCases";
import ViewFlooringCases from "./pages/FlooringCases/ViewFlooringCases";
import IssueAAF from "./pages/FlooringCases/View/IssueAAF";
import PreviewAAF from "./pages/FlooringCases/View/PreviewAAF";
import AAFSetup from "./pages/AAFSetup";
import CaseSummary from "./pages/FlooringCases/View/CaseSummary";
import ViewSOA from "./pages/FlooringCases/View/ViewSOA";
import FlooringNotificationLayout from "./pages/FlooringNotification";
import ViewRedemption from "./pages/FlooringCases/View/ViewRedemption";
import ResetPassword from "./pages/ResetPassword";
import TokenHandler from "./components/TokenHandler/TokenHandler";
import DealerCommisionReport from "./pages/DealerCommisionReport";
import ViewInvoice from "./pages/LoanApplicationCases/ViewInvoice";


export const AuthenticationContext = createContext(null);
function App() {
  const dispatch = useDispatch();
  const tokenId = localStorage.getItem("agentModuleToken");
  const [authData, setAuthData] = useState(null);
  const [compLoad, setCompLoad] = useState(false);
  const Permissions = authData?.permissions?.map((it) => it.submodules).flat();

  useEffect(() => {
    async function setSettings() {
      let res = await axios.get("/settings");
      //console.log("settings", res);
      dispatch(update(res.data.data));
    }
    setSettings();
  }, []);
  const { isLoading } = useQuery(
    "auth",
    async () => {
      const resp = await axios
        .get("/profile/info", {
          headers: {
            Authorization: `Bearer ${tokenId}`,
          },
        })
        .catch(function (error) {
          localStorage.removeItem("agentModuleToken");
          window.location.href = "login";
        });
      //console.log(resp?.data?.data);
      setAuthData(resp?.data?.data);
      return resp?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !authData && tokenId !== null,
    }
  );

  return (
    <>
      {compLoad || isLoading ? (
        <PageLoader />
      ) : (
        <AuthenticationContext.Provider value={{ authData, setAuthData }}>
          <div className="App">
            <ToastContainer position={"top-left"} autoClose={2500} />
            <BrowserRouter basename='/agent'>
              <TokenHandler setCompLoad={setCompLoad} setAuthData={setAuthData} />
              <ScrollToTop />
              <Routes>
                <Route
                  path="/"
                  element={
                    <AuthRoute>
                      <DashboardLayout />
                    </AuthRoute>
                  }
                >
                  <Route
                    index
                    element={
                      <AuthRoute>
                        <Dashboard />
                      </AuthRoute>
                    }
                  />
                  <Route
                    path="/loan-products"
                    element={
                      <ProtectedRoute>
                        <LoanProduct />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/loan-products/:id"
                    element={<SingleLoanProduct />}
                  />
                  <Route
                    path="/dealer-bonus"
                    element={
                      <ProtectedRoute>
                        <DealerBonus />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/accounts/profile" element={<Profile />} />
                  <Route
                    path="/case-list"
                    element={
                      <ProtectedRoute>
                        <CaseList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/case-detail"
                    element={
                      <ProtectedRoute>
                        <CaseDetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/case-detail-documents"
                    element={
                      <ProtectedRoute>
                        <DownloadDocuments />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/case-detail-status"
                    element={
                      <ProtectedRoute>
                        <ApplicationCaseStatus />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/preview-aa"
                    element={
                      <ProtectedRoute>
                        <PreviewAA />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/case-summary"
                    element={
                      <ProtectedRoute>
                        <CaseSumary />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/view-invoice"
                    element={<ViewInvoice />}
                  />
                  <Route
                    path="/guarantor-detail"
                    element={
                      <ProtectedRoute>
                        <GuarantorDetailsComponent />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/view-aa"
                    element={
                      <ProtectedRoute>
                        <ViewAA />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/aa-setup"
                    element={
                      <ProtectedRoute>
                        <Aasetup />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/view-application"
                    element={
                      <ProtectedRoute>
                        <ViewApplicationForm />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/notification/application_updates"
                    element={
                      <ProtectedRoute>
                        <NotificationLayout />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/notification/flooring_updates"
                    element={
                      <ProtectedRoute>
                        <FlooringNotificationLayout />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/user-accounts"
                    element={
                      <ProtectedRoute>
                        <UserAccounts />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/user-roles"
                    element={
                      <ProtectedRoute>
                        <UserRoles />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/bonus-summary" element={<BonusSummary />} />
                  <Route
                    path="/bonus-summary/detailsummary"
                    element={<DetailSummary />}
                  />
                  <Route
                    path="/bonus-summary/payment-history"
                    element={<PaymentHistory />}
                  />
                  <Route path="user-accounts" element={<UserAccounts />} />
                  <Route path="user-roles" element={<UserRoles />} />
                  <Route path="/flooring-rates" element={<FlooringRates />} />
                  <Route
                    path="/flooring-vouchers"
                    element={<FlooringVouchers />}
                  />{" "}
                  <Route path="/flooring-cases" element={<FlooringCases />} />
                  <Route
                    path="/flooring-cases/view"
                    element={<ViewFlooringCases />}
                  />
                  <Route
                    path="/flooring-cases/view/summary"
                    element={<CaseSummary />}
                  />
                  <Route
                    path="/flooring-cases/view/viewSOA"
                    element={<ViewSOA />}
                  />
                  <Route
                    path="/flooring-cases/view/viewRedemption"
                    element={<ViewRedemption />}
                  />
                  <Route
                    path="/flooring-cases/view/issueAAF"
                    element={<IssueAAF />}
                  />
                  <Route
                    path="/flooring-cases/view/issueAAF/preview"
                    element={<PreviewAAF />}
                  />
                  <Route path="/flooring-aaf-setup" element={<AAFSetup />} />
                  <Route path="/no-permission" element={<NoPermission />} />
                  <Route path="/dealer-commision-report" element={<DealerCommisionReport />} />
                </Route>
                <Route path="/login" element={<Login />} />
                <Route path="/resetpassword/:id" element={<ResetPassword />} />
              </Routes>
            </BrowserRouter>
          </div>
        </AuthenticationContext.Provider>
      )}
    </>
  );
}

export default App;
